import api from './api';

export const getAssessments = (params) => api.get('/api/assessments', { params });
export const getAssessment = (id) => api.get(`/api/assessments/${id}`);
export const createAssessment = (data) => api.post('/api/assessments', data);
export const updateAssessment = (id, data) => api.put(`/api/assessments/${id}`, data);
export const publishAssessment = (id) => api.put(`/api/assessments/${id}/publish`);
export const deleteAssessment = (id) => api.delete(`/api/assessments/${id}`);
export const getScoreSummary = (params) => api.get('/api/assessments/score-summary', { params });
